import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {RootState} from 'store';

export interface CreatePrsStep1State {
    sessionId: number;
    candidateId: number;
    serviceTypeId: number;
    registrationId: number;
    countryId: number;
    components: { value: number, label: string }[];
}

export interface CreatePrsStep2State {
    tncAccepted : boolean;
}

export interface CreatePrsComponentsState {
    step1: CreatePrsStep1State | null,
    step2: CreatePrsStep2State,
    payFromList: boolean,
    prsJustCreated : boolean,
}

const initialState: CreatePrsComponentsState = {
    step1: null,
    step2: {
        tncAccepted: false
    },
    payFromList: false,
    prsJustCreated: false,
};

export const prsSlice = createSlice({
    name: 'prs',
    initialState,
    reducers: {
        setComponents: (state, action: PayloadAction<CreatePrsStep1State>) => {
            state.step1 = action.payload;
        },
        setTc: (state, action: PayloadAction<CreatePrsStep2State>) => {
            state.step2.tncAccepted = action.payload.tncAccepted;
            
        },
    },
    extraReducers: (builder) => {
        builder
            .addDefaultCase(() => {});

    },
});

export const {setComponents, setTc} = prsSlice.actions;

export const selectCreatePrsStep1Values = (state: RootState): CreatePrsStep1State | null => state.prs.step1;
export default prsSlice.reducer;
